(ns manage.adset-decision-tree-page.editor.hooks
  (:require ["@xyflow/react" :refer [useReactFlow useStoreApi]]
            [cljs-bean.core :refer [->clj]]
            [uix.core :as uix :refer [defhook]]))

(defhook use-fit-view []
  (let [reactflow-instance (useReactFlow)
        fit-view (.-fitView reactflow-instance)]
    (uix/use-callback
     (fn [node-ids]
       (fit-view #js {:nodes (to-array (map (fn [id] #js {:id id}) node-ids))
                      :padding (if (< 1 (count node-ids)) 0.5 4)
                      :duration 150}))
     [fit-view])))

(defhook use-get-is-node-in-viewport []
  (let [{:keys [isNodeIntersecting]} (->clj (useReactFlow))
        store-api (useStoreApi)]
    (uix/use-callback (fn [viewport node-id]
                        (let [{:keys [x y zoom]} (->clj viewport)
                              {:keys [width height nodes]} (->clj (.getState store-api))]
                          (when (contains? (set (map :id nodes)) node-id)
                            (isNodeIntersecting #js {:id node-id}

                                                ;; Viewport Rect
                                                #js {:x (/ x zoom -1)
                                                     :y (/ y zoom -1)
                                                     :width (/ width zoom)
                                                     :height (/ height zoom)}

                                                ;; partial intersection
                                                true))))
                      [isNodeIntersecting store-api])))
